import LottieView from 'lottie-react-native';
import React from 'react';
import { View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { Text } from '@/ui';

interface LoaderProps {
  style?: any;
  title?: string;
  body?: string;
}

export const Loader = ({ style, title, body }: LoaderProps) => {
  const { styles, theme } = useStyles(stylesheet);

  const source =
    UnistylesRuntime.themeName === 'dark'
      ? require('@/../public/images/loader-dark.json')
      : require('@/../public/images/loader-light.json');

  return (
    <View style={[styles.container, style]}>
      <LottieView
        source={source}
        style={styles.lottie}
        webStyle={styles.lottie}
        autoPlay
        loop
        resizeMode="contain"
      />

      {title && (
        <Text type="title2" style={{ textAlign: 'center' }}>
          {title}
        </Text>
      )}

      {body && (
        <Text
          type="bodyRegular"
          style={{ color: theme.colors.text.secondary, textAlign: 'center' }}
        >
          {body}
        </Text>
      )}
    </View>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    zIndex: 1000,
    width: '100%',
    height: '100%',
  },
  lottie: {
    width: '80%',
    height: '80%',
  },
}));
